import React from 'react';

/**
 * ProductCard Molecule Component
 * Displays a single product card with image, pharmacode, longDescription, and price
 */
const ProductCard = ({ 
  product = {},
  onAddToCart,
  className = '',
  ...props 
}) => {
  const { 
    id,
    pharmacode = '',
    longDescription = '',
    currentPrice = null,
    originalPrice = null,
    inDiscount = false,
    discountPercentage = null,
  } = product;

  // Use placeholder image for now
  const imageUrl = 'https://via.placeholder.com/300x300';
  const displayPrice = currentPrice !== null ? currentPrice : originalPrice;
  const hasPrice = displayPrice !== null;

  return (
    <div 
      className={`bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 ${className}`}
      {...props}
    >
      {/* Product Image */}
      <div className="aspect-square w-full bg-gray-200 overflow-hidden">
        <img 
          src={imageUrl} 
          alt={longDescription || pharmacode}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Product Info */}
      <div className="p-4">
        {/* Pharmacode */}
        {pharmacode && (
          <div className="text-xs text-gray-500 mb-1">
            Code: {pharmacode}
          </div>
        )}

        {/* Long Description */}
        <h3 className="text-lg font-semibold text-gray-900 mb-3 line-clamp-3">
          {longDescription || 'No description available'}
        </h3>

        {/* Price */}
        <div className="flex items-center justify-between">
          {hasPrice ? (
            <div className="flex items-center gap-2">
              {inDiscount && originalPrice && (
                <span className="text-sm text-gray-500 line-through">
                  ${originalPrice.toFixed(2)}
                </span>
              )}
              <span className={`text-xl font-bold ${inDiscount ? 'text-red-600' : 'text-blue-600'}`}>
                ${displayPrice.toFixed(2)}
              </span>
              {inDiscount && discountPercentage && (
                <span className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded">
                  -{discountPercentage}%
                </span>
              )}
            </div>
          ) : (
            <span className="text-sm text-gray-500">Price not available</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;

